<template>
  <x-page title="开具发票" :loading="loading">
    <div class="wrapper">
      <ul>
        <li>
          <div>发票类型</div>
          <div>增值税电子普通发票</div>
        </li>
        <li>
          <div>抬头类型</div>
          <div>
            <van-radio-group
              v-model="type"
              :disabled="orderData.invoiceIsNoWrite"
            >
              <van-radio name="1" checked-color="#ee0a24">
                个人或事业单位
              </van-radio>
              <van-radio name="2" checked-color="#ee0a24">企业</van-radio>
            </van-radio-group>
          </div>
        </li>

        <li>
          <div>发票抬头</div>
          <input
            v-model="name"
            :disabled="orderData.invoiceIsNoWrite"
            :placeholder="type === '1' ? '填写开票人姓名' : '填写公司名称'"
            maxlength="30"
          />
        </li>
        <li v-if="type === '2'">
          <div>税号</div>
          <input v-model="taxNo" placeholder="纳税人识别号" maxlength="30" />
        </li>
      </ul>
      <button
        v-track="{
          name: '开具发票-确认开票',
          id: 'e7f9f38e-46e7-40fc-9f3b-36e003d6073a',
        }"
        class="iPhoneXMargin"
        @click="handleSubmitClick"
      >
        确认开票
      </button>
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderOrderDetail, apiOrderOrderModifyInvoice } from '@/api'
  import { mapQuery, prepareData, submit, Track } from '@/utils'
  import { navigateBack } from '@/router'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      mapQuery({
        // 订单编号
        orderNo: 'orderNo',
      }),
      Track.provideMark(() => ({
        page: '开具发票',
      })),
    ],

    data() {
      return {
        // 加载中状态
        loading: true,

        // 订单数据
        orderData: {},

        // 类型：1 个人  2 企业
        type: '1',

        // 抬头
        name: '',

        // 税号，仅企业
        taxNo: '',
      }
    },

    async mounted() {
      const { orderData } = await prepareData({
        orderData: apiOrderOrderDetail({
          orderNo: this.orderNo,
        }),
      })

      this.orderData.invoiceIsNoWrite = false
      this.type = orderData.invoiceInfo?.titleType.toString() || '1'
      this.name =
        orderData.invoiceInfo?.title ||
        (orderData.invoiceIsNoWrite && orderData.userAuthName) ||
        ''
      this.taxNo = orderData.invoiceInfo?.taxPayerNumber || ''
      this.loading = false
    },

    methods: {
      handleSubmitClick() {
        submit(async $ => {
          if (this.name === '') {
            return $.fail('请输入发票抬头')
          }
          if (this.type === '2' && this.taxNo === '') {
            return $.fail('请输入税号')
          }
          $.start()
          await apiOrderOrderModifyInvoice({
            merchantId: this.orderData.merchantId,
            orderNo: this.orderNo,
            title: this.name,
            titleType: this.type,
            taxPayerNumber: this.taxNo || undefined,
          })
          await $.success('发票开具成功')
          navigateBack()
        })
      },
    },
  })
</script>

<style lang="scss" scoped>
  .wrapper {
    padding: 12px;
  }

  ul {
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      padding-top: 16px;
    }

    li:first-child {
      padding-top: 0;
    }
  }

  button {
    width: 351px;
    height: 44px;
    background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
    border-radius: 21px;
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    position: fixed;
    bottom: 20px;
  }

  .van-radio-group {
    display: flex;
  }

  ::v-deep .van-radio__label {
    margin-left: 4px !important;
  }

  ::v-deep .van-radio {
    margin-left: 16px;
  }

  input {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: right;
    border: none;
  }

  input::placeholder {
    color: #bebebe;
  }
</style>
